import { useMemo } from "react";

/** Azure SWA logout URL that returns the user to /portal/login. */
export function useSignOutHref(): string {
  return useMemo(() => {
    const postLogout = encodeURIComponent(
      `${window.location.origin}/portal/login`
    );
    return `/.auth/logout?post_logout_redirect_uri=${postLogout}`;
  }, []);
}
